import { AdsTitle } from '../get-data/transform/ads-title';

export const UPDATE_ADS_TITLE = 'UPDATE_ADS_TITLE';

export const updateAdsTitle = (payload: AdsTitle) => ({
    type: UPDATE_ADS_TITLE,
    payload,
});

export const initialData: AdsTitle = {
    plainText: '',
    totalNumberOfAdsFound: '0',
    categorySeoDisplayName: '',
};

export default (state = initialData, action: ReturnType<typeof updateAdsTitle>) => {
    return action.type === UPDATE_ADS_TITLE ? { ...state, ...action.payload } : state;
};
